import { render, staticRenderFns } from "./PanelAffirmation.vue?vue&type=template&id=2adbb06a&"
import script from "./PanelAffirmation.vue?vue&type=script&lang=js&"
export * from "./PanelAffirmation.vue?vue&type=script&lang=js&"
import style0 from "./PanelAffirmation.vue?vue&type=style&index=0&id=2adbb06a&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2adbb06a')) {
      api.createRecord('2adbb06a', component.options)
    } else {
      api.reload('2adbb06a', component.options)
    }
    module.hot.accept("./PanelAffirmation.vue?vue&type=template&id=2adbb06a&", function () {
      api.rerender('2adbb06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/PanelAffirmation.vue"
export default component.exports